import React from 'react'
import { 
    Network, 
    ShieldCheck, 
    AlertTriangle, 
    TrendingUp, 
    Layers, 
    Sigma 
} from 'lucide-react'
import { TaskService } from '@duck/api-definitions'
import { TranslationKey } from '@/modules/i18n/types'
import { cn } from '@duck/ui'

interface Proficiency {
    label: TranslationKey
    icon: (className?: string) => React.ReactElement
}

export const TASK_PROFICIENCIES: Record<TaskService.TaskProficienciesEnum, Proficiency> = {
    [TaskService.TaskProficienciesEnum.Joins]: {
        label: 'tasks.proficiencies.joins',
        icon: (className?: string) => React.createElement(Network, { className: cn('h-4 w-4', className) }),
    },
    [TaskService.TaskProficienciesEnum.DataSanitization]: {
        label: 'tasks.proficiencies.dataSanitization',
        icon: (className?: string) => React.createElement(ShieldCheck, { className: cn('h-4 w-4', className) }),
    },
    [TaskService.TaskProficienciesEnum.AnomalyDetection]: {
        label: 'tasks.proficiencies.anomalyDetection',
        icon: (className?: string) => React.createElement(AlertTriangle, { className: cn('h-4 w-4', className) }),
    },
    [TaskService.TaskProficienciesEnum.TimeSeriesAnalysis]: {
        label: 'tasks.proficiencies.timeSeriesAnalysis',
        icon: (className?: string) => React.createElement(TrendingUp, { className: cn('h-4 w-4', className) }),
    },
    [TaskService.TaskProficienciesEnum.WindowFunctions]: {
        label: 'tasks.proficiencies.windowFunctions',
        icon: (className?: string) => React.createElement(Layers, { className: cn('h-4 w-4', className) }),
    },
    [TaskService.TaskProficienciesEnum.Aggregation]: {
        label: 'tasks.proficiencies.aggregation',
        icon: (className?: string) => React.createElement(Sigma, { className: cn('h-4 w-4', className) }),
    },
}


